module.exports = __webpack_public_path__ + "img/novobanco.0ee1ad01.svg";